import { Dropdown, Space } from "antd";
import { useNavigate } from "react-router-dom";

import {
    DownOutlined,
    HomeOutlined,
    CodeOutlined,
    BookOutlined,
} from '@ant-design/icons';

export default function Menu() {
    const navigator = useNavigate();

    const goToHome = () => {
        navigator("/");
    };

    const goToProjectQueue = () => {
        navigator("/projects");
    }

    const goToBookQueue = () => {
        navigator("/backlog");
    };

    const items = [
        {
            key: '1',
            // eslint-disable-next-line
            label: (<a onClick={goToHome}>Home</a>),
            icon: <HomeOutlined />
        },
        {
            key: '2',
            // eslint-disable-next-line
            label: (<a onClick={goToProjectQueue}>Project Queue</a>),
            icon: <CodeOutlined />
        },
        // {
        //     key: '3',
        //     // eslint-disable-next-line
        //     label: (<a onClick={goToBookQueue}>Book Queue </a>),
        //     icon: <BookOutlined />
        // },
    ];

    return(
        <>
            <Dropdown menu={{ items }} size="large">
                <button onClick={(e) => e.preventDefault()}>
                    <Space>
                        Menu <DownOutlined/>
                    </Space>
                </button>
            </Dropdown>
        </>
    )
}